<p
	class="grid grid-cols-2 gap-3 mt-4 sm:items-center sm:flex sm:mt-0 sm:flex-shrink-0 sm:pl-4"
>
	@if (isFeatured()) {
		<uc-request-btn
			[params]="uniId()"
			componentName="Course Listing"
			customStyles="w-full md:w-auto !py-3"
			[product]="product()"
			[courseName]="courseName()"
			[ugSearchOrderPosition]="ugSearchOrderPosition()"
		/>
	}
	@if (externalUrl() && isFeatured()) {
		<uc-visit-website-btn
			customStyles="w-full !py-3"
			[externalUrl]="externalUrl()"
			[product]="product()"
			componentName="Course Listing"
			[uniId]="uniId()"
			buttonText="Website"
			[source]="courseName()"
			[uniName]="uniName()"
			sourceType="course"
			[ugSearchOrderPosition]="ugSearchOrderPosition()"
		/>
	}
	<uc-bookmark
		class="hidden sm:block"
		[saved]="isCourseSaved()"
		[id]="courseId()"
		[uniName]="uniName()"
		[courseSlug]="courseSlug()"
		[delta]="2"
		[showDesktopOnMobile]="true"
		componentName="Course Listing"
		[product]="product()"
		[bookmarkHeartIcon]="true"
		[ugSearchOrderPosition]="ugSearchOrderPosition()"
		[cleSearchOrderPosition]="null"
		[academicYear]="academicYear()"
	/>
</p>
